module.exports = __webpack_public_path__ + "video-thumbnail-privacy-dac4fa42d9a25228b883fcf3c7704dd2.jpg";